import { forwardRef, useState } from "react";

import EyeIcon from "@/assets/icons/eye.svg";
import EyeOffIcon from "@/assets/icons/eye-off.svg";
import Clickable from "@components/Clickable";
import Adornment from "@components/Field/Adornment";

import InputField, { FieldProps } from "../InputField";

import styles from "./PasswordField.module.css";

/**
 * PasswordField
 * A regular field but enhanced with an eye to keep what you're typing secret unless
 * you manually untoggle it
 */
const PasswordField = forwardRef<HTMLInputElement, FieldProps>((props, ref) => {
  const [viewPassword, setViewPassword] = useState(false);
  return (
    <InputField
      type={viewPassword ? "text" : "password"}
      endAdornment={
        <Adornment
          position="end"
          clickthrough={false}
          className={styles.adornment}
        >
          <Clickable
            tabIndex={-1}
            onClick={() => setViewPassword((v) => !v)}
            className={styles.showPassword}
          >
            {viewPassword ? <EyeOffIcon /> : <EyeIcon />}
          </Clickable>
        </Adornment>
      }
      {...props}
      ref={ref}
    />
  );
});

PasswordField.displayName = "PasswordField";

export default PasswordField;
